export default {
  path: 'invoiceOpen',
  component: () => import(/* webpackChunkName: "lecturer-list" */ '@/pages/invoice/invoiceOpen'),
  meta: {title: '发票代开', cate: '结算管理'},
  children: [
    {
      path: ':detail/view',
      component: () => import(/* webpackChunkName: "article-create" */ '@/pages/invoice/invoiceDetail'),
      meta: {title: '发票代开详情'},
    },
  ]
}